/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum FormError {
	INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
	BOTH_OR_NEITHER = 'BOTH_OR_NEITHER',
	ENTRY_BEFORE_DEPARTURE = 'ENTRY_BEFORE_DEPARTURE',
	REQUIRED = 'REQUIRED',
	FORMAT = 'FORMAT',
	VERIFY_EMAIL = 'VERIFY_EMAIL',
	DUPLICATE_EMAIL = 'DUPLICATE_EMAIL',
	VERIFY_DOMAIN = 'VERIFY_DOMAIN',
	DUPLICATE_DOMAIN = 'DUPLICATE_DOMAIN',
	PASSWORD_NOT_MATCHED = 'PASSWORD_NOT_MATCHED',
	PASSWORD_CONFIRM_REQUIRED = 'PASSWORD_CONFIRM_REQUIRED',
	DUPLICATE_DATA = 'DUPLICATE_DATA',
	NO_PHONE_NUMBER = 'NO_PHONE_NUMBER',
	OCCURRENCE_DATE_REQUIRED = 'OCCURRENCE_DATE_REQUIRED',
	ASSIGNMENT_DATE = 'ASSIGNMENT_DATE',
	OCCURRENCE_DATE_MIN_MAX = 'OCCURRENCE_DATE_MIN_MAX',
	WORK_START_DATE = 'WORK_START_DATE',
	WORK_END_DATE = 'WORK_END_DATE',
	FORMAT_COMMON_INVALID = 'FORMAT_COMMON_INVALID',
	IPV4 = 'IPV4',
}

export enum UploadExcelError {
	//COMMON
	NOT_NULL = 'NOT_NULL',
	INVALID_FORMAT = 'INVALID_FORMAT',
	INVALID_LENGTH = 'INVALID_LENGTH',
	NOT_FOUND = 'NOT_FOUND',
	INVALID_VALUE_LIST = 'INVALID_VALUE_LIST',
	EMAIL_ID_NOT_MATCH = 'EMAIL_ID_NOT_MATCH',
	DUPLICATE = 'DUPLICATE',

	//LM
	EXCEL_LM_2 = 'LM1_FRANCHISE_NOT_FOUND',
	EXCEL_LM_3 = 'LM1_RECOMMENDER_NOT_FOUND',
	EXCEL_LM_4 = 'LM1_INVALID_DISTRICT',
	EXCEL_LM_5 = 'LM1_DISTRICT_NOT_MAPPING',
	EXCEL_LM_6_FRANCHISE = 'LM1_FRANCHISE_DUPLICATE',
	EXCEL_LM_6_RECOMMENDER = 'LM1_RECOMMENDER_DUPLICATE',

	//RM
	RM1_TYPE_NOT_CORRECT = 'RM1_TYPE_NOT_CORRECT',
	RM1_SPOUSE_NAME_NOT_EXIST = 'RM1_SPOUSE_NAME_NOT_EXIST',

	//AR
	EXCEL_AR_1 = 'CAN_NOT_INPUT_PUBLIC_FRANCHISE',
	EXCEL_AR_2 = 'AR1_PUBLIC_FRANCHISE_NOT_FOUND',
	EXCEL_AR_3 = 'AR1_IMPORT_DUPLICATE_WITH_NAME_AND_BIRTH_DATE',
	EXCEL_AR_4 = 'AR1_CANNOT_INPUT_REENTRY_APPLICANT',
	EXCEL_AR_6 = 'AR1_INVALID_EXTENSION_PERIOD',
	EXCEL_AR_7_1 = 'AR1_CANNOT_INPUT_VISA_TIME',
	EXCEL_AR_7_2 = 'AR1_CANNOT_INPUT_VISA_EXTENSION_PERIOD',
	EXCEL_AR_8 = 'AR1_VISA_TIME_MUST_NOT_C4',
	EXCEL_AR_9_1 = 'AR1_VISA_TIME_MUST_BE_C4',
	EXCEL_AR_9_2 = 'AR1_C4_CANNOT_INPUT_VISA_EXTENSION_PERIOD',
	EXCEL_AR_11 = 'AR1_APPLICANT_HAS_ASSIGNMENT_AVAILABLE',
	EXCEL_AR_12 = 'EXCEL_AR_12',
	AR1_IMPORT_DUPLICATE_EMAIL = 'AR1_IMPORT_DUPLICATE_EMAIL',
	AR1_INVALID_END_DATE = 'AR1_INVALID_END_DATE',
	AR1_CANNOT_CHANGE_PUBLIC_APPLICANT = 'AR1_CANNOT_CHANGE_PUBLIC_APPLICANT',
	EXCEL_AR_ALL_5 = 'AR1_INVALID_DISTRICT',
	EXCEL_AR_ALL_6 = 'AR1_DISTRICT_NOT_MAPPING',
	EXCEL_AR_ALL_7 = 'AR1_CANNOT_CHANGE_DISTRICT',
	EXCEL_AR_ALL_8 = 'SYS_MANDATORY_INPUT_DISTRICT_FIRST',
	AR1_MID_TERM_DEPARTURE_DATE_IS_NULL = 'AR1_MID_TERM_DEPARTURE_DATE_IS_NULL',
	AR1_MID_TERM_DEPARTURE_DATE_IS_PAST = 'AR1_MID_TERM_DEPARTURE_DATE_IS_PAST',

	//FR
	CAN_NOT_INPUT_PUBLIC_FRANCHISE = 'CAN_NOT_INPUT_PUBLIC_FRANCHISE',
	FR1_PUBLIC_MAIN_FRANCHISE_NOT_FOUND = 'FR1_PUBLIC_MAIN_FRANCHISE_NOT_FOUND',
	FR1_INVALID_GRADE = 'FR1_INVALID_GRADE',
	FR1_DUPLICATE_BUSINESS_CORPORATE_REGIST_NO = 'FR1_DUPLICATE_BUSINESS_CORPORATE_REGIST_NO',
	EXCEL_FR_5 = 'FR1_INVALID_PUBLIC_MAIN_FRANCHISE',
	EXCEL_FR_6 = 'FR1_EXCEL_6',
	EXCEL_FR_7 = 'FR1_EXCEL_7',
	EXCEL_FR_8 = 'FR1_PUBLIC_FRANCHISE_CANNOT_INPUT_PRODUCTION_TYPE',
	EXCEL_FR_ALL_5 = 'FR1_INVALID_DISTRICT',
	EXCEL_FR_ALL_6 = 'FR1_DISTRICT_NOT_MAPPING',
	EXCEL_FR_ALL_7 = 'FR1_CANNOT_CHANGE_DISTRICT',
	EXCEL_FR_ALL_8 = 'FR1_MANDATORY_INPUT_DISTRICT_FIRST',

	//AM
	AM1_INVALID_REQUEST_APPLICANT = 'AM1_INVALID_REQUEST_APPLICANT',
	AM1_INVALID_FRANCHISE_EMAIL = 'AM1_INVALID_FRANCHISE_EMAIL',
	AM1_INVALID_APPLICANT_EMAIL = 'AM1_INVALID_APPLICANT_EMAIL',
	AM1_INVALID_FRANCHISE_NAME = 'AM1_INVALID_FRANCHISE_NAME',
	AM1_INVALID_APPLICANT_FIRST_NAME = 'AM1_INVALID_APPLICANT_FIRST_NAME',
	AM1_INVALID_APPLICANT_LAST_NAME = 'AM1_INVALID_APPLICANT_LAST_NAME',
	AM1_INVALID_APPLICANT_BIRTH_DATE = 'AM1_INVALID_APPLICANT_BIRTH_DATE',
	AM1_INVALID_ROW = 'AM1_INVALID_ROW',
	AM1_DUPLICATE_APPLICANT = 'AM1_DUPLICATE_APPLICANT',
	AM1_INVALID_WORKING_DATE = 'AM1_INVALID_WORKING_DATE',
	AM1_PROGRAM_NOT_FOUND = 'AM1_PROGRAM_NOT_FOUND',
	AM1_CANNOT_ASSIGN_PUBLIC_APPLICANT = 'AM1_CANNOT_ASSIGN_PUBLIC_APPLICANT',
	AM1_INVALID_DISTRICT_ALERT_63 = 'AM1_INVALID_DISTRICT_ALERT_63',

	EXCEL_AM_1 = 'EXCEL_AM_1', //TODO: change error code
	EXCEL_AM_4 = 'AM1_INVALID_APPLICANT_AM4',
	EXCEL_AM_6 = 'AM1_INVALID_DISTRICT',
	AM1_PUBLIC_INVALID_APPLICANT = 'AM1_PUBLIC_INVALID_APPLICANT',
	AM1_PUBLIC_NOT_ENOUGH_MALE = 'AM1_PUBLIC_NOT_ENOUGH_MALE',
	AM1_PUBLIC_NOT_ENOUGH_FEMALE = 'AM1_PUBLIC_NOT_ENOUGH_FEMALE',
	AM1_PUBLIC_NOT_ENOUGH_FEMALE_AND_MALE = 'AM1_PUBLIC_NOT_ENOUGH_FEMALE_AND_MALE',

	//AM_PUBLIC_ASSIGNMENT
	AM1_PUBLIC_INVALID_FRANCHISE = 'AM1_PUBLIC_INVALID_FRANCHISE',
	AM1_PUBLIC_INVALID_REQUEST_APPLICANT = 'AM1_PUBLIC_INVALID_REQUEST_APPLICANT', // excel-PAM-1
	AM1_PUBLIC_DUPLICATE_APPLICANT_OR_FRANCHISE = 'AM1_PUBLIC_DUPLICATE_APPLICANT_OR_FRANCHISE', // excel-PAM-5
	AM1_PUBLIC_NOT_FOUND_APPLICANT = 'AM1_PUBLIC_NOT_FOUND_APPLICANT', // excel-PAM-3
	AM1_PUBLIC_APPLICANT_OR_FRANCHISE_BIRTHDAY_NULL = 'AM1_PUBLIC_APPLICANT_OR_FRANCHISE_BIRTHDAY_NULL', // excel-PAM-4
	AM1_PUBLIC_INVALID_REQUEST_APPLICANT_MANUAL = 'AM1_PUBLIC_INVALID_REQUEST_APPLICANT_MANUAL',
	AM1_PUBLIC_INVALID_RELAX_TIME = 'AM1_PUBLIC_INVALID_RELAX_TIME', // excel-PAM-6
	AM1_PUBLIC_EXIST_ASSIGNMENT = 'AM1_PUBLIC_EXIST_ASSIGNMENT', // excel-PAM-7
	AM1_PUBLIC_APPLICANT_FRANCHISE_NOT_MATCH_PUBLIC_FRANCHISE = 'AM1_PUBLIC_APPLICANT_FRANCHISE_NOT_MATCH_PUBLIC_FRANCHISE', // excel-PAM-8

	//OTHER
	MULTIPLE_DATA = 'MULTIPLE_DATA',
	IMPORT_ERROR = 'IMPORT_ERROR',
	INVALID_END_DATE = 'INVALID_END_DATE',
	UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}
